import { render } from "./AdminWrapperView.vue?vue&type=template&id=3ecdbd2a&ts=true"
import script from "./AdminWrapperView.vue?vue&type=script&lang=ts"
export * from "./AdminWrapperView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__